var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.807,
    height: 18.288,
    viewBox: "0 0 16.807 18.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12778",
    "data-name": "Group 12778",
    transform: "translate(-1215.922 -1643.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setting",
    transform: "translate(1216.814 1644.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M2.209,0A2.209,2.209,0,1,1,0,2.209,2.209,2.209,0,0,1,2.209,0Z",
    transform: "translate(5.301 6.185)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M14.728,4.2h0a2.177,2.177,0,0,0-2.986-.806A1.364,1.364,0,0,1,9.7,2.2,2.195,2.195,0,0,0,7.51,0h0A2.195,2.195,0,0,0,5.324,2.2,1.363,1.363,0,0,1,3.28,3.392,2.178,2.178,0,0,0,.293,4.2a2.211,2.211,0,0,0,.8,3.008,1.379,1.379,0,0,1,0,2.378,2.211,2.211,0,0,0-.8,3.008,2.178,2.178,0,0,0,2.986.806h0a1.363,1.363,0,0,1,2.044,1.189h0a2.195,2.195,0,0,0,2.186,2.2h0a2.195,2.195,0,0,0,2.186-2.2h0A1.363,1.363,0,0,1,11.742,13.4a2.178,2.178,0,0,0,2.986-.806,2.211,2.211,0,0,0-.8-3.008h0a1.378,1.378,0,0,1,0-2.378A2.21,2.21,0,0,0,14.728,4.2Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.12ee72f2a4e5122f285e647c49631346.svg";
export { ForwardRef as ReactComponent };